import { Divider, Heading, Stack, Text, TextLink } from 'braid-design-system';

import type {
  NotificationCtpCategory,
  NotificationCtpPreference,
} from 'src/types/graphql';

import SubscriptionToggle from './subscription-toggle';

interface ProductToggleProps {
  preference: NotificationCtpPreference;
  categoryId: NotificationCtpCategory['id'];
}

const ProductToggle: React.FC<ProductToggleProps> = ({
  preference,
  categoryId,
}) => {
  const { product, subscriptions } = preference;

  return (
    <Stack space="medium">
      <Heading level="4">{product.label}</Heading>
      <Text tone="secondary">{product.description}</Text>
      {subscriptions.map((subscription) => (
        <SubscriptionToggle
          key={subscription.id}
          product={product}
          subscription={subscription}
          categoryId={categoryId}
        />
      ))}
      {product.action?.path && product.action?.label ? (
        <Text tone="secondary">
          <TextLink
            href={product.action.path}
            data={{ testid: product.action.label }}
          >
            {product.action.label}
          </TextLink>
        </Text>
      ) : null}
      <Divider />
    </Stack>
  );
};

export default ProductToggle;
